export enum Entity {
  Insurance = 'insurance',
  Takaful = 'takaful',
}

export enum EntityTypeId {
  EGIB = 1,
  EGTB = 2,
}

export enum EntityTypeKey {
  EGIB = 'egib',
  EGTB = 'egtb',
}
